const environment = {
    apiURL: 'https://api.adventistas.app/api/v1'
}

export default environment;